module.exports = __webpack_public_path__ + "media/svg-new/logo-full-bfaa3b4d.svg";